import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Standard React Router ScrollToTop Component
 * Automatically resets scroll position to the top on every route navigation
 * Handles both window-level scroll and internal layout container scroll.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 1. Reset standard browser window scroll
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });

    // 2. Reset any internal scrollable main containers (e.g., Dashboard Layouts)
    const scrollContainers = document.querySelectorAll('main, .overflow-y-auto');
    scrollContainers.forEach((container) => {
      if (container) {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      }
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
